__turbopack_context__.v({
  "active": "button-module__4pa5-q__active",
  "button": "button-module__4pa5-q__button",
  "default": "button-module__4pa5-q__default",
  "ideeri-dark": "button-module__4pa5-q__ideeri-dark",
  "ideeri-light": "button-module__4pa5-q__ideeri-light",
  "ideeri-primary": "button-module__4pa5-q__ideeri-primary",
  "ideeri-secondary": "button-module__4pa5-q__ideeri-secondary",
  "rounded": "button-module__4pa5-q__rounded",
  "secondary": "button-module__4pa5-q__secondary",
  "small": "button-module__4pa5-q__small",
});
